module.exports = __webpack_public_path__ + "static/img/curo-dis-product.c07f9a24.jpg";